/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CodeEditorStartOnAssignmentDescriptionSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('CODE_EDITOR_START_ON_ASSIGNMENT_DESCRIPTION'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CodeEditorStartOnAssignmentDescriptionSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CodeEditorStartOnAssignmentDescriptionSettingParser.decode(input).map(res => new CodeEditorStartOnAssignmentDescriptionSetting(res));
    }
    static unsafeDecode(input) {
        return CodeEditorStartOnAssignmentDescriptionSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CodeEditorStartOnAssignmentDescriptionSettingParser.encode(data);
    }
    static schema() {
        return CodeEditorStartOnAssignmentDescriptionSettingParser.schema();
    }
}
